export default __webpack_public_path__ + "static/media/findus.585c393c.png";